import * as Permission from './Permission';

export const SNAPSHOT_TEST_PERMISSION_ERROR = 'PERM_DEVELOPER or PERM_INSTANCE_DEVELOPER permission required';
export const SNAPSHOT_TEST_ORGANISATION_ERROR = 'Snapshot test access requires organisation membership or PERM_DEVELOPER permission';

export function hasSnapshotTestDeveloperPermission(permissionObject) {
    return Permission.hasPermissionInternal(Permission.PERM_DEVELOPER, permissionObject) ||
        Permission.hasPermissionInternal(Permission.PERM_INSTANCE_DEVELOPER, permissionObject);
}

export function hasSnapshotTestPlatformPermission(permissionObject) {
    return Permission.hasPermissionInternal(Permission.PERM_DEVELOPER, permissionObject);
}

export function getSnapshotTestOrganisationIds(permissionObject) {
    if (!permissionObject || !Array.isArray(permissionObject.organisationPermissions)) {
        return [];
    }

    return [...new Set(permissionObject.organisationPermissions
        .map((organisationPermission) => organisationPermission && organisationPermission.organisation_id)
        .filter(Boolean)
        .map(String))];
}

export function hasSnapshotTestRowPermission(permissionObject, organisationId) {
    if (!hasSnapshotTestDeveloperPermission(permissionObject)) {
        return false;
    }

    if (hasSnapshotTestPlatformPermission(permissionObject)) {
        return true;
    }

    if (!organisationId) {
        return false;
    }

    return getSnapshotTestOrganisationIds(permissionObject).includes(String(organisationId));
}
